import BasicDataTable from "../../Component/BasicComponents/BasicDataTable";

const OnboardingRequestLogDataColumns = [
  {
    name: "Log detail",
    selector: (row: { Description: string }) => row?.Description || "-",
    sortable: true,
    wrap: true,
  },

  {
    name: "Status",
    selector: (row: { Status: string }) => row.Status || "-",
    sortable: true,
  },

  {
    name: "Log by",
    selector: (row: any) => {
      const firstName = row?.Employee?.FirstName || "";
      const lastName = row?.Employee?.LastName || "";
      const code = row?.Employee?.EmployeeCode || "";
      return `${firstName} ${lastName} |  ${code}`.trim() || "-";
    },
    sortable: true,
  },

  {
    name: "Log time & date",
    selector: (row: { CreatedAt: string }) => {
      return row?.CreatedAt?.split(".")[0].replace("T", " ");
    },
    sortable: true,
  },
];
const OnboardingRequestLog = ({
  onboardingRequestLogsData,
  setFilterOnboardRequestLogsState,
}: {
  onboardingRequestLogsData: any;
  setFilterOnboardRequestLogsState: any;
}) => {
  const handlePagination = (pageNo: number) => {
    setFilterOnboardRequestLogsState((prevState: any) => {
      return {
        ...prevState,
        start: pageNo,
      };
    });
  };
  const handleonChangeRowsPerPage = (limit: any, pageNo: any) => {
    setFilterOnboardRequestLogsState((prevState: any) => {
      return {
        ...prevState,
        start: pageNo,
        length: limit,
      };
    });
  };

  return (
    <div>
      <BasicDataTable
        Title="Request Logs"
        columns={OnboardingRequestLogDataColumns}
        data={onboardingRequestLogsData?.data?.data || []}
        search={false}
        onChangePage={(pageNo: number) => {
          handlePagination(pageNo);
        }}
        onChangeRowsPerPage={(newPerPage: any, page: any) => {
          handleonChangeRowsPerPage(newPerPage, page);
        }}
        paginationTotalRows={onboardingRequestLogsData?.data?.recordsTotal || 0}
      />
    </div>
  );
};

export default OnboardingRequestLog;
